import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "name", "company", "email", "telephone", "address"]
  static values = { mode: { type: String, default: "billing" } }

  change() {
    const contactId = this.selectTarget.value
    if (!contactId) return

    fetch(`/admin/custom_contacts/${contactId}.json`, {
      headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" }
    })
      .then(response => {
        if (response.ok) return response.json()
        throw new Error("Failed to load")
      })
      .then(data => {
        if (this.hasNameTarget) this.nameTarget.value = data.name || ""
        if (this.hasCompanyTarget) this.companyTarget.value = data.company || ""
        if (this.hasEmailTarget) this.emailTarget.value = data.email || ""
        if (this.hasTelephoneTarget) this.telephoneTarget.value = data.telephone || ""
        if (this.hasAddressTarget) {
          const addr = this.modeValue === "shipping" ? data.shipping_address : data.billing_address
          this.addressTarget.value = addr || ""
        }
        this.selectTarget.value = ""
      })
      .catch(() => {})
  }
}
